import { CSVLink } from 'react-csv';
import { ExportIcon } from '@assets/index';
import { useStyles } from './styles/ExportCSV.styles';

interface ExportCSVProps {
    headers: any[];
    rows: any[];
    fileName: string;
}

export const ExportCsv = ({ headers, rows, fileName }: ExportCSVProps) => {
    const classes = useStyles();

    return (
        <CSVLink className={classes.exportButton} headers={headers} data={rows} filename={`${fileName}.csv`}>
            <ExportIcon style={{ width: 20, height: 20 }} />
            Export
        </CSVLink>
    );
};
